import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

export type FinalizeReportConfirmDialogData = {
  expectedLastName: string;
  title?: string;
  message?: string;
};

@Component({
  selector: 'app-finalize-report-confirm-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  templateUrl: './finalize-report-confirm-dialog.component.html',
  styleUrls: ['./finalize-report-confirm-dialog.component.scss'],
})
export class FinalizeReportConfirmDialogComponent {
  readonly lastNameCtrl = new FormControl<string>('', { nonNullable: true, validators: [Validators.required] });

  readonly data = inject(MAT_DIALOG_DATA, { optional: true }) as FinalizeReportConfirmDialogData | null;
  private readonly dialogRef = inject(MatDialogRef<FinalizeReportConfirmDialogComponent, boolean>, { optional: true });

  private normalize(value: string): string {
    return (value ?? '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[^a-z]/g, '');
  }

  get canConfirm(): boolean {
    const expected = this.normalize(this.data?.expectedLastName ?? '');
    const typed = this.normalize(this.lastNameCtrl.value ?? '');
    return !!expected && !!typed && expected === typed;
  }

  confirm(): void {
    if (!this.canConfirm) return;
    this.dialogRef?.close(true);
  }

  cancel(): void {
    this.dialogRef?.close(false);
  }
}
